import Browser from '@mindful-web/marko-web/browser';
import Global from '@randall-reilly/package-global/browser';

const EquipmentCalculator = () => import(/* webpackChunkName: "site-top250-table" */ './equipment-calculator.vue');

const { EventBus } = Browser;
Global(Browser);

Browser.register('EquipmentCalculator', EquipmentCalculator, { provide: { EventBus } });

// @todo figure out what else to track
EventBus.$on('equipmentCalculator_submit', (payload) => {
  window.dataLayer.push({ event: 'equipmentCalculator_submit', ...payload });
});

export default Browser;
